"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/contexts/auth-provider";
import { isSystemAdmin } from "@/lib/utils";

export default function RedirectPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/login");
      return;
    }
    // Só a conta técnica admin@admin cai direto na administração; os demais
    // administradores (pessoas reais que também participam de eventos) têm
    // o mesmo perfil de usuário padrão, com uma aba extra para administrar.
    if (isSystemAdmin(user)) {
      router.replace("/admin/dashboard");
    } else {
      router.replace("/user/dashboard");
    }
  }, [user, loading, router]);

  return <p>Carregando...</p>;
}
